/**
 * @author  : 王冲
 * @desc    : 登录钩子
 */

import { regHook } from '@weapp/utils';

export function registerHook<T>(hookname: string, fn: (data: T) => Promise<T>) {
	const hooksRules = [
		'beforeLoginRender',
		'afterLoginRender',
		'beforeLogin',
		'afterLogin'
	]
	if (hooksRules.includes(hookname)) {
		regHook('weappPassportWeb', hookname, fn)
	}
}